<div class="tidy-phone-field">
  @if (label) {
    <tidy-text
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!disableElement && !form?.valid && submitted" />
  }

  <div
    class="input-container"
    [class.invalid-field]="!disableElement && !form?.valid && submitted"
    [class.no-border]="noBorder"
    [class.focused]="focused"
    (click)="$event.target === $event.currentTarget && phoneInput.focus()">

    @if (icon) {
      <tidy-image [src]="icon" class="input-icon no-right-margin" />
    }

    <input
      appBlockCopyPaste
      [imask]="initialMask"
      [unmask]="true"
      #phoneInput
      [disabled]="disableElement"
      [value]="phoneValue"
      [placeholder]="helperText || '' | translate"
      (keydown)="changeTouch()"
      (input)="onInputChange()"
      formnovalidate="formnovalidate"
      [type]="type"
      [attr.inputMode]="inputMode"
      (focus)="setFocused(true); checkFocused()"
      (focusout)="setFocused(false); checkFocusedout($event)"
      [autocomplete]="autoComplete" />
  </div>

  @if (submitted && !disableElement && !form?.valid) {
    <tidy-error-message [text]="errorMessage" />
  }
</div>
